import type { FaireProductEntity } from "../../entity_types/product";

export const p_qttjjkdhjt: FaireProductEntity = {
  token: "p_qttjjkdhjt",
  type: "product",
  name: "Happy Plaid Chunky Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/74a29ea0f6c646adc9fb9f8f95e20de355b9e6d6f274118ed67c5385ef76c835.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b6a2cb23422b6069bfbfcf5089a510e41fe77988cf459fe08ee97981877ceb7b.jpeg",
    "https://cdn.faire.com/fastly/69c432d24927a1a6d7662fe8108365fcc0f68794bb64f3d34d8f9cb98811ef46.jpeg",
  ],
  priceDollars: 9,
  description:
    "Big and chunky. It's how we like our desserts and this awesome square notepad. This is the guy you pull out when you need an extra sturdy surface for those big, chunky ideas.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:49.787Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
